<mat-card>
  <mat-card-header>
    <mat-card-title>Búsqueda de Expensas Liquidadas</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="canView">

      <mat-expansion-panel *ngIf="!isValidating">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="searchForm">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label>Fecha Expensa Desde</mat-label>
                <input matInput [matDatepicker]="fechaExpensaDesdePicker" formControlName="FechaExpensaDesde" (click)="fechaExpensaDesdePicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaExpensaDesdePicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaExpensaDesde')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaExpensaDesdePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Fecha Expensa Hasta</mat-label>
                <input matInput [matDatepicker]="fechaExpensaHastaPicker" formControlName="FechaExpensaHasta" (click)="fechaExpensaHastaPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaExpensaHastaPicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaExpensaHasta')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaExpensaHastaPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label>Fecha Vencimiento Desde</mat-label>
                <input matInput [matDatepicker]="fechaVencimientoDesdePicker" formControlName="FechaVencimientoDesde"  (click)="fechaVencimientoDesdePicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoDesdePicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaVencimientoDesde')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaVencimientoDesdePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Fecha Vencimiento Hasta</mat-label>
                <input matInput [matDatepicker]="fechaVencimientoHastaPicker" formControlName="FechaVencimientoHasta"  (click)="fechaVencimientoHastaPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoHastaPicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaVencimientoHasta')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaVencimientoHastaPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="!esUsuarioFinal">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isMonedaSearching">Moneda</mat-label>
                <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                <mat-select formControlName="MonedaId">
                  <mat-option>Todas</mat-option>
                  <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="!esUsuarioFinal">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isEstadoSearching">Estados</mat-label>
                <mat-label *ngIf="isEstadoSearching">Cargando...</mat-label>
                <mat-select formControlName="EstadoId">
                  <mat-option>Todos</mat-option>
                  <mat-option *ngFor="let s of estadoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="!esUsuarioFinal">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isConsorcioSearching">{{'Consorcio' | translate}}</mat-label>
                <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
                <mat-select formControlName="ConsorcioId">
                  <mat-option>Todos</mat-option>
                  <mat-option *ngFor="let s of consorcioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                <mat-select formControlName="ComunidadId">
                  <mat-option>Todas</mat-option>
                  <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            
          </div>

          <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!esUsuarioFinal">
            <mat-checkbox formControlName="VerSoloActivos" (keyup.enter)="onSearch()" color="primary">Ver Solo Activos</mat-checkbox>
          </div>

        </form>

      </mat-expansion-panel>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
        <button mat-raised-button (click)="add()" *ngIf="canEdit" [disabled]="isSearching" color="primary" class="zb-button">Nueva Liquidación</button>
        <button mat-raised-button (click)="config()" *ngIf="canConfig" [disabled]="isSearching" class="zb-button">Configurar Expensas</button>
        <button mat-raised-button (click)="onSearch()" [disabled]="isSearching" color="primary" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
        <button mat-raised-button (click)="onExport()" [disabled]="isExporting" color="warn" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">
        <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
          [pageSettings]='pageSettings' [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
          <e-columns>
            <e-column field='ExpensaPeriodo' headerText='Período' width=90></e-column>
            <e-column field='ComunidadNombre' headerText='Comunidad' width=90>
              <ng-template #headerTemplate let-data>
                {{'Comunidad' | translate}}
              </ng-template>
            </e-column>
            <!-- <e-column field='MonedaCodigo' headerText='Moneda' width=90></e-column> -->
            <e-column field='Importe' headerText='Importe' width=90 textAlign="right">
              <ng-template #template let-data>
                {{data.MonedaCodigo}} {{data.Importe | number:'1.2-2'}}
              </ng-template>
            </e-column>
            <e-column field='FechaVencimiento' headerText='Vencimiento' width=90>
              <ng-template #template let-data>
                {{data.FechaVencimiento | date:'dd/MM/yyyy'}}
              </ng-template>
            </e-column>
            <e-column field='Estado' headerText='Estado' width=90 *ngIf="!esUsuarioFinal"></e-column>
            <e-column field='Activo' headerText='Activo?' width=90 *ngIf="!esUsuarioFinal">
              <ng-template #template let-data>
                {{data.Activo ? 'Sí' : 'No'}}
              </ng-template>
            </e-column>
            <e-column headerText='Acciones' width=90>
              <ng-template #template let-data>
                <a style="cursor: pointer; margin-right: 5px" (click)="edit(data)"><i class="fa fa-eye fa-1x"></i></a>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>

    </ng-container>

  </mat-card-content>
</mat-card>
